import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ThemeProvider } from 'styled-components';

class ThemeManager extends Component {
  state = {
    themeStyles: {},
  };

  componentDidMount() {
    // this component will only we mounted when the user has logged in
    // we can now lazy load the theme
    // eslint-disable-next-line max-len
    import(/* webpackChunkName: "theme" */ `../themes/${this.props.theme}.js`).then((themeStyles) => {
      this.setState({ themeStyles: themeStyles.default });
    });
  }

  render() {
    const { children } = this.props;
    const { themeStyles } = this.state;
    return (
      <ThemeProvider theme={themeStyles}>
        {Object.keys(themeStyles).length > 0 ? children : null}
      </ThemeProvider>
    );
  }
}

ThemeManager.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.string,
};

const mapStateToProps = state => ({
  theme: state.user.brand || 'default',
});

export default connect(mapStateToProps)(ThemeManager);
